import { render, staticRenderFns } from "./ContasReceberAtrasadas.vue?vue&type=template&id=0d802524&"
import script from "./contasReceberAtrasadas.js?vue&type=script&lang=js&"
export * from "./contasReceberAtrasadas.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports